'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var createMint = require('./operations/createMint.cjs');
var createToken = require('./operations/createToken.cjs');
var createTokenWithMint = require('./operations/createTokenWithMint.cjs');
var mintTokens = require('./operations/mintTokens.cjs');
var sendTokens = require('./operations/sendTokens.cjs');
var freezeTokens = require('./operations/freezeTokens.cjs');
var thawTokens = require('./operations/thawTokens.cjs');
var approveTokenDelegateAuthority = require('./operations/approveTokenDelegateAuthority.cjs');
var revokeTokenDelegateAuthority = require('./operations/revokeTokenDelegateAuthority.cjs');

/**
 * This client allows you to access the underlying Transaction Builders
 * for the write operations of the Token module.
 *
 * @see {@link TokenClient}
 * @group Module Builders
 * */
class TokenBuildersClient {
  constructor(metaplex) {
    this.metaplex = metaplex;
  }

  // -----------------
  // Create
  // -----------------

  /** {@inheritDoc createMintBuilder} */
  createMint(input, options) {
    return createMint.createMintBuilder(this.metaplex, input, options);
  }

  /** {@inheritDoc createTokenBuilder} */
  createToken(input, options) {
    return createToken.createTokenBuilder(this.metaplex, input, options);
  }

  /** {@inheritDoc createTokenIfMissingBuilder} @internal */
  createTokenIfMissing(input, options) {
    return createToken.createTokenIfMissingBuilder(this.metaplex, input, options);
  }

  /** {@inheritDoc createTokenWithMintBuilder} */
  createTokenWithMint(input, options) {
    return createTokenWithMint.createTokenWithMintBuilder(this.metaplex, input, options);
  }

  // -----------------
  // Update
  // -----------------

  /** {@inheritDoc mintTokensBuilder} */
  mint(input, options) {
    return mintTokens.mintTokensBuilder(this.metaplex, input, options);
  }

  /** {@inheritDoc sendTokensBuilder} */
  send(input, options) {
    return sendTokens.sendTokensBuilder(this.metaplex, input, options);
  }

  /** {@inheritDoc freezeTokensBuilder} */
  freeze(input, options) {
    return freezeTokens.freezeTokensBuilder(this.metaplex, input, options);
  }

  /** {@inheritDoc thawTokensBuilder} */
  thaw(input, options) {
    return thawTokens.thawTokensBuilder(this.metaplex, input, options);
  }

  // -----------------
  // Delegate
  // -----------------

  /** {@inheritDoc approveTokenDelegateAuthorityBuilder} */
  approveDelegateAuthority(input, options) {
    return approveTokenDelegateAuthority.approveTokenDelegateAuthorityBuilder(this.metaplex, input, options);
  }

  /** {@inheritDoc revokeTokenDelegateAuthorityBuilder} */
  revokeDelegateAuthority(input, options) {
    return revokeTokenDelegateAuthority.revokeTokenDelegateAuthorityBuilder(this.metaplex, input, options);
  }
}

exports.TokenBuildersClient = TokenBuildersClient;
//# sourceMappingURL=TokenBuildersClient.cjs.map
